import React from 'react';
import PropTypes from 'prop-types';
import apiFetch from 'modules/api-fetch';
import { Form, Field } from 'formik';
import ReactPlayer from 'react-player';
import ReactHtmlParser from 'react-html-parser';
import { Progress } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import Toast from 'modules/toast';
import Loading from 'modules/loading';
import { find, maxBy } from 'lodash';
import Textarea from 'modules/components/web/textarea';
import Config, { genderTypeMap } from 'modules/config';
import moment from 'moment';
import Picker from 'react-giphy-picker';
import Swal from 'sweetalert2';
import IMAGES from 'modules/assets/web';
import { uploadFile } from 'modules/file-handling';
import Dropzone from 'modules/components/web/dropzone';
import ClientStatusLegend from 'modules/components/web/chat/src/ClientStatusLegend';

import MessagesClientPush from './TrainerFacing/MessagesClientPush';
import MessagesEventPrefs from './TrainerFacing/MessagesEventPrefs';
import MessageTemplatePicker from './TrainerFacing/MessageTemplatePicker';
import MessagesVideoControl from './TrainerFacing/MessagesVideoControl';

// https://www.npmjs.com/package/emoji-picker-react

class ChatTextBox extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    refreshEverything: PropTypes.func.isRequired,
    // nextClientId: PropTypes.any.isRequired,
    handleChange: PropTypes.func.isRequired,
    clientData: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    trainerId: PropTypes.number.isRequired,
    setSubmitting: PropTypes.func.isRequired,
    focused: PropTypes.bool,
    resetImageForm: PropTypes.bool.isRequired,
    className: PropTypes.string.isRequired,
    scrollToBottom: PropTypes.func.isRequired,
    myClient: PropTypes.object.isRequired,
    myTrainer: PropTypes.object.isRequired,
    fullChatRoom: PropTypes.object.isRequired,
    clientChatRoomId: PropTypes.number.isRequired,
  };

  static defaultProps = {
    focused: false,
  };

  state = {
    // showEmojiPicker: false,
    showImagePicker: false,
    showGifPicker: false,
    loadedMedia: null,
    loadedFileName: '',
    loadedFileSize: '',
    fileUploadProgress: '',
    videoUploaded: false,
    imageUploaded: false,
    isMediaLoading: false,
  };

  componentDidUpdate() {
    if (this.props.resetImageForm) {
      this.resetImagePicker();
    }
  }

  onTextareaEnterPress = (e) => {
    if (e.keyCode === 13 && (e.ctrlKey === true || e.metaKey === true)) {
      e.preventDefault();
      this.props.handleSubmit();
    }
    return null;
  };

  setImagePreview = (file) => {
    // console.devLog.info('File:', file);
    const reader = new FileReader();
    reader.onload = (readerFile) => {
      let videoUrl = readerFile.target.result;
      if (file.type.includes('quicktime')) {
        videoUrl = URL.createObjectURL(file);
      }
      this.setState({
        loadedMedia: videoUrl,
        loadedFileName: file.name,
        loadedFileSize: parseInt(file.size / 1000 / 1000, 10),
      });
    };
    reader.readAsDataURL(file);
  };

  setFileUploadProgress = (value) => {
    this.setState({
      fileUploadProgress: value,
    });
  };

  newUploadFile = async (file) => {
    this.setState({ isMediaLoading: true });
    if (file.size / 1000 / 1000 > 500) {
      Toast.error('That file is over 500mb, host it on YouTube or something!');
      this.resetImagePicker();
      return;
    }

    if (
      this.props.myClient.data[0].chatMedium === 2 &&
      file.size / 1000 / 1000 > 4
    ) {
      Toast.error('Files sent via SMS must be under 4mb.', {
        duration: 10000,
      });
      this.resetImagePicker();
      return;
    }

    this.setImagePreview(file);
    // console.devLog.info('File??', file);
    try {
      if (file.type.includes('video/webm')) {
        // fetch needs to use FormData for file
        const data = new FormData();
        data.append('file', file);
        const config = {
          url: 'Trainer/CreateRecordedChatVideo',
          query: {
            chatRoomId: this.props.clientChatRoomId,
          },
          method: 'POST',
          isFormData: true,
          body: data,
          timeoutMS: 90000,
        };
        await apiFetch(config);

        // The server actually 'sends' the message at this point
        Toast.success('Video Sent!');
        this.setState({
          isMediaLoading: false,
          loadedFileName: '',
          loadedFileSize: '',
        });
        // Refresh data??
        this.props.refreshEverything();
      } else {
        try {
          const fileGuid = await uploadFile(
            file,
            undefined,
            this.setFileUploadProgress,
            'ChatPhotoBucket',
          );

          if (file.type.includes('video')) {
            this.props.setFieldValue('videoUrl', fileGuid);
            // this.props.values.videoUrl = fileGuid;
            this.setState({
              videoUploaded: true,
            });
          } else if (file.type.includes('image')) {
            this.props.setFieldValue('imageUrl', fileGuid);
            // this.props.values.imageUrl = fileGuid;
            this.setState({
              imageUploaded: true,
            });
          } else {
            Toast.error('Error: Does not match any allowed format.');
            throw new Error('Does not match allowed formats');
          }

          Toast.success('Media loaded into message.');
        } catch (e) {
          console.log('Erro uploading media');
        }
      }
    } catch (err) {
      Toast.error('Error uploading media');
      console.devLog.info('Error uploading media:', err);
      this.setState({
        isMediaLoading: false,
      });
    }
    this.setState({
      isMediaLoading: false,
    });
    this.props.refreshEverything();
    this.props.setSubmitting(false);
  };

  imagePreview = () => (
    <img
      className="image-preview mb-4 d-block "
      src={this.state.loadedMedia}
      alt="Trainer"
    />
  );

  filePreviewName = () => <div>File Name: {this.state.loadedFileName}</div>;

  filePreviewSize = () => <div>File Size: {this.state.loadedFileSize} Mb</div>;

  fileProgress = () => (
    <div>
      <Progress value={this.state.fileUploadProgress} />
    </div>
  );

  videoPreview = () => (
    <div className="react-player-wrapper react-player-mini">
      <ReactPlayer
        url={this.state.loadedMedia}
        className="react-player-player"
        width="100%"
        height="100%"
        controls
      />
    </div>
  );

  filePicked = (file) => {
    // console.devLog.info('File:', e);
    // const file = e.target.files[0];
    this.newUploadFile(file);
  };

  fileUploader = () => (
    <Dropzone {...this.props} handleUploadFile={this.filePicked} />
  );

  gifPicker = () => (
    <Picker
      onSelected={(gif) => {
        const gifUrl = gif.downsized.url;

        this.props.setFieldValue('imageUrl', gifUrl);
        // this.props.values.imageUrl = gifUrl;
        this.setState({
          loadedMedia: gifUrl,
          loadedFileName: gifUrl,
          imageUploaded: true,
          loadedFileSize: parseInt(gif.downsized.size / 1000 / 1000, 10),
          showGifPicker: false,
        });
      }}
    />
  );

  pushWarning = () => {
    // Notify the trainer if the client will not get a push notification for this
    const clientData = this.props.myClient.data[0];

    if (!Config.IS_TRAINER_APP) {
      return null;
    }

    let pushStatus = null;
    let message = '';
    try {
      pushStatus = JSON.parse(clientData.pushStatus);
    } catch (e) {
      console.devLog.info('Error parsing push status: ', pushStatus);
    }
    if (clientData.chatMedium === 1 && clientData.chatNotifications === 0) {
      message =
        "This client has disabled chat message notifications with their in-app chat notifications preference. See: <a href='https://coaching.helpscoutdocs.com/article/284-push-notification-permissions'><u>Push Notification Permissions</u></a>";
    }

    if (
      clientData.chatMedium === 1 &&
      pushStatus &&
      pushStatus.notificationsEnabled === false
    ) {
      message =
        "This client's app does not allow push notifications. See: <a href='https://coaching.helpscoutdocs.com/article/284-push-notification-permissions'><u>Push Notification Permissions</u></a>";
    }

    if (!message) {
      return null;
    }

    return (
      <div className="row">
        <div className="col text-right text-primary">
          {ReactHtmlParser(message)}
        </div>
      </div>
    );
  };

  imageUploader = () => (
    <div className="form-group p-2">
      <label htmlFor="file">Select Media</label>
      <input
        type="file"
        name="file"
        className="form-control-file"
        id="file"
        onChange={this.filePicked}
      />
    </div>
  );

  resetImagePicker = () => {
    this.setState(
      {
        showImagePicker: false,
        loadedMedia: null,
        loadedFileName: '',
        loadedFileSize: '',
        fileUploadProgress: 0,
        videoUploaded: false,
        imageUploaded: false,
        isMediaLoading: false,
      },
      this.props.setImageReset, // eslint-disable-line
    );
  };

  // selectNextClient = () => {
  //   this.props.history.push({
  //     pathname: `/messages/${this.props.nextClientId}`,
  //     // state: { orderBy },
  //   });
  // };

  checkTime = async () => {
    // Check if the clients time is between 10pm and 6am and ask if they want to send a notification or not
    if (Config.IS_TRAINER_APP && this.props.myClient.data[0].chatMedium === 1) {
      const clientOffset = this.props.myClient.data[0].utcOffset;
      // const clientOffset = 600;
      const clientTime = moment().utcOffset(clientOffset).format('h:mm a');

      // Outputs in military hours so we can tell if it's too early or too late regardless of day
      const clientHour = moment().utcOffset(clientOffset).format('HH');

      const isTimeLate = clientHour <= 6 || clientHour >= 22;

      if (isTimeLate) {
        const { dismiss } = await Swal.fire({
          showCancelButton: true,
          confirmButtonText: 'Notify',
          type: 'warning',
          cancelButtonText: 'No Notification',
          showCloseButton: true,
          text: `The client's current time is: ${clientTime}, do you want to send a notification?`,
        });

        if (dismiss === 'cancel') {
          this.props.setFieldValue('sendNotification', false);
        }
      }
    }

    this.props.handleSubmit();
  };

  render() {
    const { className } = this.props;
    const clientData = this.props.myClient.data[0];
    const gender = find(
      genderTypeMap,
      (item) => item.value == clientData.gender,
    );

    let genderInitial = 'N/A';

    if (gender) {
      genderInitial = gender.label.substring(0, 1);
    }
    const justifyBox = Config.IS_TRAINER_APP
      ? 'justify-content-between'
      : 'justify-content-end';

    // console.log('Client data??', clientData);
    const lastCall = maxBy(clientData.callLogs, 'time');
    let lastCallTime = null;
    if (lastCall) {
      lastCallTime = lastCall.time;
    }
    return (
      <div className={`chat-text-box bg-white ${className}`}>
        <Form className="d-flex flex-column" id="chatTextBox">
          <div className="row align-items-center w-100 position-relative ml-0 ">
            <Field
              // component={this.TextareaComponent}
              name="text"
              placeholder="Enter text here..."
              render={() => (
                <Textarea
                  values={this.props.values}
                  handleChange={this.props.handleChange}
                  fieldName="text"
                  form="chatTextBox"
                  focused={this.props.focused}
                  rows={5}
                  onKeyDown={this.onTextareaEnterPress}
                />
              )}
            />
            <div
              className={`d-flex w-100 mt-2 mb-1 ml-1 align-items-center flex-column flex-sm-row ${justifyBox}`}
            >
              {Config.IS_TRAINER_APP && (
                <>
                  <ClientStatusLegend client={clientData} />

                  <div className="d-flex">
                    {clientData.firstName} {clientData.lastName}
                    {' | '}
                    {clientData.nickname && `${clientData.nickname} | `}
                    {moment().diff(clientData.birthday, 'years')}
                    {genderInitial}
                    {' | '}
                    {moment().utcOffset(clientData.utcOffset).format('h:mm a')}
                    {' | '}
                    {moment(lastCallTime).isValid()
                      ? moment().diff(moment(lastCallTime), 'days')
                      : 'N/A'}{' '}
                    days since last call
                    {' | '}
                    {moment().diff(clientData.lastTrainerVideo, 'days')} days
                    since last video
                    {' | '}
                    Last Logged In:{' '}
                    {moment(clientData.appTimestampUTC).format('MM/DD hh:mm a')}
                  </div>
                </>
              )}
              <div className="d-flex justify-content-end flex-wrap ">
                {this.props.isSubmitting && (
                  <div className="mr-auto">
                    <Loading inline /> Sending...
                  </div>
                )}
                {/* <button
                className="btn chat-textbox-select ml-2"
                type="button"
                onClick={() => {
                  window.alert(
                    "To use emoji use your system's picker. On a mac press cmd + control + space. On windows press Win + period OR Win + semicolon",
                  );
                }}
              >
                Emoji
              </button> */}

                {Config.IS_TRAINER_APP && (
                  <MessagesEventPrefs clientData={this.props.myClient} />
                )}
                {Config.IS_TRAINER_APP && (
                  <MessagesClientPush clientData={this.props.myClient} />
                )}
                {Config.IS_TRAINER_APP && (
                  <MessageTemplatePicker
                    trainerId={this.props.trainerId}
                    setFieldValue={this.props.setFieldValue}
                    myClient={this.props.myClient}
                    myTrainer={this.props.myTrainer}
                    fullChatRoom={this.props.fullChatRoom}
                  />
                )}
                {Config.IS_TRAINER_APP && (
                  <MessagesVideoControl
                    fileUpload={this.newUploadFile}
                    refreshEverything={this.props.refreshEverything}
                    myClient={this.props.myClient}
                  />
                )}
                <button
                  className="btn chat-textbox-select ml-2"
                  type="button"
                  onClick={() => {
                    this.setState(
                      {
                        showImagePicker: !this.state.showImagePicker,
                      },
                      () => this.props.scrollToBottom(),
                    );
                    // e.preventDefault();
                  }}
                >
                  <img alt="Select" src={IMAGES.PHOTO} />
                </button>
                <button
                  className="btn chat-textbox-select ml-2"
                  type="button"
                  onClick={() => {
                    this.setState(
                      {
                        showGifPicker: !this.state.showGifPicker,
                      },
                      () => this.props.scrollToBottom(),
                    );
                    // e.preventDefault();
                  }}
                >
                  <img alt="Select" src={IMAGES.GIPHY_ICON} />
                </button>

                {/* {Config.IS_TRAINER_APP && (
                  <button
                    className="btn btn-outline-primary ml-2"
                    onClick={this.selectNextClient}
                    type="button"
                  >
                    Next
                  </button>
                )} */}

                <button
                  onClick={this.checkTime}
                  // onSubmit={this.props.handleSubmit}
                  className="btn bg-primary text-white ml-2"
                  type="button"
                  disabled={
                    this.props.isSubmitting || this.state.isMediaLoading
                  }
                >
                  SEND
                </button>
              </div>
            </div>
          </div>
          {this.pushWarning()}
          <div className="row">
            <div className="chat-box-file-handlers ml-3 mr-3 w-100">
              {this.state.showImagePicker && this.fileUploader()}
              {this.state.isMediaLoading && (
                <span>
                  <Loading inline /> Uploading media...
                </span>
              )}
              {this.state.isMediaLoading &&
                this.state.fileUploadProgress &&
                this.fileProgress()}
              {this.state.loadedFileName && this.filePreviewName()}
              {this.state.loadedFileSize && this.filePreviewSize()}
              {this.state.loadedMedia &&
                this.state.imageUploaded &&
                this.imagePreview()}
              {this.state.videoUploaded && this.videoPreview()}
            </div>
            {this.state.showGifPicker && this.gifPicker()}
          </div>
        </Form>
      </div>
    );
  }
}

export default withRouter(ChatTextBox);
